<template>
  <div class="wf-absolute wf-top-0 wf-w-full wf-overflow-hidden">
    <div class="wf-flex wf-relative wf-flex-wrap wf-h-screen">
      <div class="wf-relative wf-h-min-screen wf-overflow-scroll" :style="contentWidth">
        <draggable
          v-model="sections"
          group="sections"
          handle=".section-handle"
          class="wf-absolute wf-w-full wf-top-0 wf-min-h-screen wf-overflow-x-hidden"
          :class="! previewMode ? 'wf-bg-gray-100': 'wf-bg-white'"
        >
          <EditorSection
            v-for="section in sections"
            :element="section.element"
            :key="section.id"
          />
        </draggable>
        <component
          v-for="component in components"
          :is="component.slug"
          :component="component"
          :key="component.id"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
import EditorSection from './EditorSection'
  export default {
    components: { draggable, EditorSection },
    data() {
      return {
        contentWidth: {width: '100%'}
      }
    },
    watch: {
      editingElement() {
        this.calculateContentWidth()
      },
      previewMode() {
        this.calculateContentWidth()
      },
      elementMenuOpen() {
        this.calculateContentWidth()
      },
    },
    mounted() {
      window.addEventListener('resize', this.calculateContentWidth)
    },
    computed: {
      previewMode() {
        return this.$store.state.previewMode
      },
      editingElement() {
        return this.$store.state.editingElement
      },
      module() {
        return 'pageModule'
      },
      elementMenuOpen() {
        return this.$store.state.elementToolbar
      },
      sections: {
        get() {
          return this.$store.getters['sectionModule/elements']()
        },
        set(value) {
          this.$store.dispatch('sectionModule/updateOrder', {value})
        }
      },
      components() {
        return this.$store.getters['pageComponentModule/elements']()
      }
    },
    methods: {
      calculateContentWidth() {
        if (! this.editingElement || this.previewMode) {
          return this.contentWidth = {width: '100%'}
        }
        if (this.elementMenuOpen) {
          return this.contentWidth = {width: `${window.innerWidth - 320}px` }
        }
        return this.contentWidth = {width: `${window.innerWidth - 72}px` }
      }
    },
  }
</script>